import { render, staticRenderFns } from "./resource_parent_link.vue?vue&type=template&id=65ba623a"
import script from "./resource_parent_link.vue?vue&type=script&lang=js"
export * from "./resource_parent_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports